import { get } from './get';

const portfolioAdapter = {
  get
};

export { portfolioAdapter };
